<script lang="ts">
  import type { Snippet } from 'svelte';
  import { twMerge } from 'tailwind-merge';
  import Icon from '../Icon.svelte';

  interface Props {
    checked?: boolean;
    value?: string | null;
    disabled?: boolean;
    indeterminate?: boolean;
    center?: boolean;
    name?: string;
    onchange?: (detail: { checked: boolean; value: string | null }) => void;
    children?: Snippet;
  }

  let {
    checked = $bindable(true),
    value = null,
    disabled = false,
    indeterminate = false,
    center = false,
    name = undefined,
    onchange,
    children,
  }: Props = $props();

  let inputElement: HTMLInputElement;

  const toggleCheck = () => {
    if (disabled) return;
    inputElement.checked = !checked;
    inputElement.dispatchEvent(new Event('change'));
    checked = !checked && !indeterminate;
    onchange?.({ checked, value });
  };

  const classes = $derived(
    twMerge([
      'w-5 h-5 flex items-center justify-center rounded border transition border-gray-6 group-hover:border-white group-hover:text-white',
      (checked || indeterminate) &&
        'bg-white text-black border-white group-hover:text-black',
      disabled &&
        'bg-gray-9 text-gray-3 border-gray-9 group-hover:border-gray-9 group-hover:text-gray-3',
    ]),
  );
</script>

<input
  class="hidden"
  type="checkbox"
  bind:this={inputElement}
  {checked}
  {name}
/>

<button
  type="button"
  class="flex items-center {center
    ? 'justify-center'
    : ''} group w-full cursor-pointer gap-2"
  onclick={(event) => {
    event.stopPropagation();
    toggleCheck();
  }}
>
  <div class={classes}>
    {#if indeterminate}
      <Icon icon="check_indeterminate_small" size="md" />
    {:else if checked}
      <Icon icon="check" size="md" />
    {/if}
  </div>
  <div class={twMerge('transition', !disabled && 'group-hover:text-white')}>
    {@render children?.()}
  </div>
</button>
